import { render } from "./ForgotPassword.vue?vue&type=template&id=655a994a&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=js"
export * from "./ForgotPassword.vue?vue&type=script&lang=js"

import "../assets/bootstrap.min.css?vue&type=style&index=0&id=655a994a&scoped=true&lang=css"
import "./ForgotPassword.vue?vue&type=style&index=1&id=655a994a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-655a994a"]])

export default __exports__